import React, { useState } from "react";
import { Label, DefaultButton, PrimaryButton, Icon } from "@fluentui/react";
import { useTheme } from "../../theme/OAS365Theme";
import { UNAUTHORIZED_USER, MICROSOFT_ACCOUNT_ISSUE_MESSAGE } from "../../redux/constants/messageTypes";
import { USER_DATA_LOAD_STATUS } from "../../redux/constants/metaData";
import { SKIP_AUTH_DIALOG_AFTER_LOGOUT } from "../../services/authService";
import logicalUnitImage from "../../assets/luError.png";

const ErrorDisplay = ({ messageBoxInfo, onRetry, userDataLoadStatus }) => {
  const theme = useTheme();
  const [showMore, setShowMore] = useState(false);
  const isAfterLogout =
    typeof localStorage !== "undefined" &&
    !!localStorage.getItem(SKIP_AUTH_DIALOG_AFTER_LOGOUT);
  const isMicrosoftAccountIssue =
    !isAfterLogout &&
    userDataLoadStatus === USER_DATA_LOAD_STATUS.onAzureUnauthorizedUser;

  const loaderBorderStyle = {
    padding: "10px auto",
    bottom: "50px",
    marginTop: "125px",
  };

  const messageBorderStyle = {
    margin: "auto",
    width: "1000px",
    paddingLeft: "0px",
  };

  const uanuthorizedImageStyles = {
    maxWidth: "100%",
    maxHeight: "80%",
    width: "300px",
    height: "300px",
    objectFit: "contain",
    objectPosition: "center",
  };

  return (
    <div style={loaderBorderStyle}>
      <div style={messageBorderStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Label
            style={{
              fontSize: theme.fontSizes.medium,
              fontWeight: theme.fontWeight.titleWeight,
              fontFamily: theme.fonts.regular,
              color: theme.colors.themeFontColor,
              display: "block",
            }}
          >
            {isAfterLogout
              ? "You have been signed out"
              : isMicrosoftAccountIssue
                ? "Microsoft authentication"
                : "We're having trouble signing you in to IFS Cloud"}
          </Label>
          <Label
            style={{
              fontSize: theme.fontSizes.normal,
              fontWeight: theme.fontWeight.normal,
              fontFamily: theme.fonts.regular,
              color: theme.colors.themeFontColor,
              display: "block",
            }}
          >
            {isAfterLogout
              ? "Sign in again when you're ready."
              : isMicrosoftAccountIssue
                ? (messageBoxInfo?.message || MICROSOFT_ACCOUNT_ISSUE_MESSAGE)
                : UNAUTHORIZED_USER}
          </Label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            id="mainPageBackground"
            src={logicalUnitImage}
            style={uanuthorizedImageStyles}
            alt="Welcome to Addovation Share"
          />
        </div>
        {showMore && !isAfterLogout && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 12,
            }}
          >
            <Label
              style={{
                fontSize: theme.fontSizes.normal,
                fontWeight: theme.fontWeight.menuWeight,
                fontFamily: theme.fonts.regular,
                color: theme.colors.themeFontColor,
                display: "block",
              }}
            >
              {messageBoxInfo.errorMessage}
            </Label>
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 12,
          }}
        >
          <DefaultButton
            onClick={() => onRetry(userDataLoadStatus)}
            styles={{
              root: {
                borderRadius: 8,
                border: `1px solid ${theme.colors.themeDarkColor}`,
                backgroundColor: "transparent",
                fontFamily: theme.fonts.regular,
                color: theme.colors.themeDarkColor,
                fontWeight: 600,
              },
              rootHovered: {
                backgroundColor: "rgba(76, 141, 106, 0.1)",
                color: theme.colors.themeDarkColor,
                fontWeight: 600,
              },
              rootPressed: {
                backgroundColor: "rgba(76, 141, 106, 0.1)",
                color: theme.colors.themeDarkColor,
                fontWeight: 600,
              },
              label: {
                color: theme.colors.themeDarkColor,
                fontWeight: 600,
                fontFamily: theme.fonts.regular,
              },
            }}
            onRenderText={() => (
              <span
                style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
              >
                {isAfterLogout ? "Login" : "Retry"}
                <Icon
                  iconName={isAfterLogout ? "SignIn" : "Refresh"}
                  styles={{ root: { color: theme.colors.themeDarkColor } }}
                />
              </span>
            )}
          />

          {!isAfterLogout && (
            <DefaultButton
              className="error-display-see-more-btn"
              text={showMore ? "See Less" : "See more"}
              onClick={() => setShowMore(!showMore)}
              styles={{
                root: {
                  borderRadius: 8,
                  backgroundColor: "#3C7D5A",
                  border: "1px solid #3C7D5A",
                  selectors: {
                    ":hover": {
                      backgroundColor: "#336D4F",
                      border: "1px solid #336D4F",
                    },
                    ":focus": {
                      backgroundColor: "#3C7D5A",
                      border: "1px solid #3C7D5A",
                    },
                    ":active": {
                      backgroundColor: "#336D4F",
                      border: "1px solid #336D4F",
                    },
                  },
                },
                rootHovered: {
                  backgroundColor: "#336D4F",
                  border: "1px solid #336D4F",
                },
                rootPressed: {
                  backgroundColor: "#3C7D5A",
                  border: "1px solid #3C7D5A",
                },
                label: {
                  fontFamily: theme.fonts.regular,
                  fontWeight: theme.fontWeight.normal,
                  color: "white",
                },
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;
